import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The McMahon Gallery</p>
        <h1>Discover Contemporary Art</h1>
        <p className="lede">
          Explore a curated selection of contemporary art and photography from talented artists around the world. Immerse yourself in creativity and inspiration at The McMahon Gallery.
        </p>
        <div className="cta-row">
          <a href="/exhibitions" target="_self">
            View Current Exhibitions
          </a>
          <a href="/artists" target="_self" className="secondary">
            Meet Our Artists
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engage with Art</h2>
          <p>
            Experience thought-provoking pieces that challenge perceptions and spark conversations. Our gallery showcases a diverse range of styles and mediums.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow art enthusiasts and participate in events, workshops, and discussions that celebrate creativity and artistic expression.
          </p>
        </article>
        <article>
          <h2>Support Emerging Artists</h2>
          <p>
            Discover and support the next generation of artists. Your visit helps foster a vibrant art community and promotes innovative talent.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;